<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Unesite poruku koja će stanarima biti poslata na mail:</p>
      <input type="text" class="form-control" v-model="emailText" />
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default close-btn btn--mod"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        :disabled="isLoading"
        @click="deleteInvoice"
      >
        <span v-if="!isLoading">Obriši</span>
        <spinner line-fg-color="#00796b" v-if="isLoading" />
      </button>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  created() {
    this.emailText = `Poštovane komšije, račun: "${
      this.invoice.description
    }" je obrisan.`;
  },
  computed: {
    ...mapState('modal', ['invoice']),
    ...mapState('finances', ['invoices'])
  },
  data() {
    return {
      emailText: '',
      isLoading: false
    };
  },
  methods: {
    ...mapMutations('table', ['setTableData']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('finances', ['getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    deleteInvoice() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      financesInstance
        .delete(`members/invoices/${this.invoice.id}`, {
          data: {
            emailText: this.emailText
          }
        })
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'invoices'
          });
          this.setTableData(this.invoices.data);
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.showFailModal();
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}

.modal-body {
  padding: 1rem 3px;
}
</style>
